<script setup lang="ts">
defineProps({
  size: {
    type: String,
    required: false,
    default: "20px"
  }
});
</script>

<template>
<span></span>
</template>

<style scoped lang="scss">
span {
  height: v-bind(size);
  width: v-bind(size);
  border: 5px solid #FFF;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
